
/**
 * 动态属性集合构件
 * @author wangjiegj<wangjiegj@inspur.com>
 */


/**
 * 动态属性集合构件
 */
export class MdRefInfo {

    /**
     * 元数据ID
     */
    public ID: string;

    /**
     * 构件元数据名称
     */
    public Name: string;

}
